import { render } from "./twelve-about.vue?vue&type=template&id=7117e9ef"
import script from "./twelve-about.vue?vue&type=script&lang=js"
export * from "./twelve-about.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__